// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t7vZ","delete":"styles_delete__2KY-i","update":"styles_update__k9LFt","add":"styles_add__2I7uJ"};